import {LonerStatics} from "../../../LonerStatics";
import {Loner} from "../../../Loner";
import {gsap, Linear} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerSound} from "../../../sound/LonerSound";
import {MAIN_FG_ANIMATION_NAMES} from "../../general/LonerForegroundView";
import {Trail} from "../../../components/Trail";
import {LonerPinTheWinBg} from "./LonerPinTheWinBg";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export interface extraInfoForPin {
    mode: string;
    nextMode: string;
    winRatio: number;
    nextWinMulti?: number;
    isRestore: boolean;
    trailRestorePos: [number, number],
    spinPlayed: number
}


export class LonerPinTheWinPinMovingView extends PIXI.Container {
    private _pinPositionsOnReels: number[][][] = [];
    private _pinTheWinWidth: number = ((LonerStatics.symbolHeight * 3) / 5) * 1.5;
    private _pinTheWinHeight: number = (390 / 5) * 1.5;
    private _pinTheWinSpriteCont: PIXI.Container;
    private _currentPositionOfPin: number[] = [0, 0];
    private _trail: Trail | null;
    private _bgOverlay: LonerPinTheWinBg;


    constructor() {
        super();
        this.getPinReelPositionFilled();
        this._pinTheWinSpriteCont = this.createPinTheWinSpriteCont();
        this._bgOverlay = new LonerPinTheWinBg();
        this.addChild(this._bgOverlay, this._pinTheWinSpriteCont);
    }

    public showHideBg(visible: boolean, durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(visible ? this._bgOverlay.showAllAssets(durr) : this._bgOverlay.hideAllAssets(durr));
        return tl;
    }


    public getAbsoluteHitPos(reelId: number, symId: number): PIXI.Point {
        const xPos: number = this._pinPositionsOnReels[reelId][symId][0],
            yPos: number = this._pinPositionsOnReels[reelId][symId][1];
        return new PIXI.Point(xPos, yPos);
    }

    public setPinPosAndVisibility(reelId: number, symId: number, visible: boolean, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.setCurrentPositionOfPin(reelId, symId);
            this._pinTheWinSpriteCont.position = this.getAbsoluteHitPos(reelId, symId);

        })
        tl.add(this.makePinVisible(visible, duration));
        return tl;
    }

    public makePinVisible(visible: boolean, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (visible) {
            this._trail = new Trail();
            this.addChild(this._bgOverlay, this._trail, this._pinTheWinSpriteCont);
        }
        tl.add(() => {
            for (let conatinerIdx: number = 0; conatinerIdx < this._pinTheWinSpriteCont.children.length; conatinerIdx++) {
                this._pinTheWinSpriteCont.children[conatinerIdx % 5].visible = false;
            }
            this._pinTheWinSpriteCont.visible = visible;
            this._pinTheWinSpriteCont.children[0].visible = visible;
        });
        tl.to([this._pinTheWinSpriteCont, this._pinTheWinSpriteCont.children[0]], duration, {alpha: visible ? 1 : 0});
        tl.to(this._pinTheWinSpriteCont, duration, {alpha: visible ? 1 : 0});
        return tl;
    }

    public movePin(destReelIdc: number, destSymIdc: number, extraInfoForPin: extraInfoForPin): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            destReelId: number = destReelIdc,
            destSymId: number = destSymIdc,
            movDistance: number = this.getMovingDistance(destReelId, destSymId),
            time: number = this.getTimeToTravel(movDistance, Loner.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? LonerStatics.MOVING_SPEED_PIXELS_PER_SECOND_FAST_SPIN : LonerStatics.MOVING_SPEED_PIXELS_PER_SECOND),
            destPos: PIXI.Point = this.getAbsoluteHitPos(destReelId, destSymId),
            isCornerHit: boolean = extraInfoForPin.mode === LonerGameMode.FEATURE_PIN_THE_WIN && extraInfoForPin.nextMode === LonerGameMode.NORMAL,
            sourcePos: PIXI.Point = this.getAbsoluteHitPos(extraInfoForPin.isRestore ? extraInfoForPin.trailRestorePos[0] : this.getCurrentPosOfPinAsReelIdSymId()[0], extraInfoForPin.isRestore ? extraInfoForPin.trailRestorePos[1] : this.getCurrentPosOfPinAsReelIdSymId()[1]);

        tl.add(() => {
            this.setCurrentPositionOfPin(destReelId, destSymId);
        });

        tl.add([
            this._bgOverlay.moveEyes(destReelIdc, destSymIdc, time),
            this._trail!.play(sourcePos, destPos, time),
            gsap.to(this._pinTheWinSpriteCont, {
                x: destPos.x,
                y: destPos.y,
                duration: time,
                ease: "none"
            })]);

        //add animation
        if (isCornerHit) {
            if(!Loner.model.brokeBank){
                tl.add(()=>{Loner.foregroundView.playAnimationByName(MAIN_FG_ANIMATION_NAMES.PTW_AMBER_GIRLS, false , 3)});
            }
            tl.add(()=>{
                let animName: MAIN_FG_ANIMATION_NAMES;
                if (destReelId === 0 && destSymId === 0) {
                    animName = MAIN_FG_ANIMATION_NAMES.PTW_CORNER_0_HIT;
                } else if (destReelId === 4 && destSymId === 0) {
                    animName = MAIN_FG_ANIMATION_NAMES.PTW_CORNER_1_HIT;
                } else if (destReelId === 0 && destSymId === 4) {
                    animName = MAIN_FG_ANIMATION_NAMES.PTW_CORNER_2_HIT;
                } else {
                    animName = MAIN_FG_ANIMATION_NAMES.PTW_CORNER_3_HIT;
                }
                Loner.foregroundView.playAnimationByName(animName);
            })
        } else {

            tl.add(() => {
                const vhsMultiplierCurrVal: number = Loner.pinTheWinVHSView.currentValue;
                if(vhsMultiplierCurrVal!==extraInfoForPin.nextWinMulti){
                    let animName: MAIN_FG_ANIMATION_NAMES = MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_TOP;
                    if (destSymId === 0) {
                        if (extraInfoForPin.nextWinMulti) {
                            animName = extraInfoForPin.nextWinMulti >= vhsMultiplierCurrVal ? MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_TOP : MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_TOP_MINUS;
                        }
                    } else if (destSymId === 4) {
                        if (extraInfoForPin.nextWinMulti) {
                            animName = extraInfoForPin.nextWinMulti >= vhsMultiplierCurrVal ? MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_BOTTOM : MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_BOTTOM_MINUS;
                        }
                    } else if (destReelId === 0) {
                        if (extraInfoForPin.nextWinMulti) {
                            animName = extraInfoForPin.nextWinMulti >= vhsMultiplierCurrVal ? MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_LEFT : MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_LEFT_MINUS;
                        }
                    } else {
                        if (extraInfoForPin.nextWinMulti) {
                            animName = extraInfoForPin.nextWinMulti >= vhsMultiplierCurrVal ? MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_RIGHT : MAIN_FG_ANIMATION_NAMES.PTW_BOUNCE_RIGHT_MINUS;
                        }
                    }
                    Loner.foregroundView.playAnimationByName(animName);
                }
            });
        }
        tl.add(() => {
            Loner.pinTheWinMainView.stopMaxWinSymbolBlink();
            this.shake(isCornerHit ? 0.2 : 0.1, isCornerHit, extraInfoForPin);
            if (isCornerHit) {
                if(!Loner.model.brokeBank){
                    if (extraInfoForPin.winRatio >= 1 && extraInfoForPin.winRatio <= 10) {
                        Loner.soundPlayer.playSound(LonerSound.PTW_LOW_WIN);
                    } else if (extraInfoForPin.winRatio >= 11 && extraInfoForPin.winRatio <= 100) {
                        Loner.soundPlayer.playSound(LonerSound.PTW_MID_WIN);
                    } else {
                        Loner.soundPlayer.playSound(LonerSound.PTW_HIGH_WIN);
                    }
                }
                Loner.soundPlayer.fadeMusic(0, 0, 0.001);
            } else {
                for (let conatinerIdx: number = 0; conatinerIdx < this._pinTheWinSpriteCont.children.length; conatinerIdx++) {
                    const visibility: boolean = this._pinTheWinSpriteCont.children[conatinerIdx].visible;
                    if (visibility) {
                        this._pinTheWinSpriteCont.children[(conatinerIdx + 1) % 5].visible = true;
                        this._pinTheWinSpriteCont.children[conatinerIdx].visible = false;
                        break;
                    }
                }
                Loner.soundPlayer.playSound(LonerSound.PTW_BOUNCE);
            }
        }, isCornerHit ? "<" : ">");
        return tl;
    }

    public clearTrail(): void {
        this._trail?.clearTrail();
        this._trail = null;
    }

    public setEyesCurrentPos(destReelIdc: number, destSymIdc: number): void {
        this._bgOverlay.setCurrentPosOfEyes(destReelIdc, destSymIdc);
    }

    private shake(dur: number, isCornerHit: boolean, extraInfoForPin: extraInfoForPin, wiggles: number = 60): gsap.core.Timeline {
        let moveXVal: number = isCornerHit ? 2 : 1,
            moveYVal: number = isCornerHit ? 2 : 1;
        const stageOriginalPos: PIXI.Point = new PIXI.Point(LonerStatics.stagePos.x, LonerStatics.stagePos.y);
        if (isCornerHit) {
            if (extraInfoForPin.winRatio >= 1 && extraInfoForPin.winRatio <= 25) {
            } else if (extraInfoForPin.winRatio >= 26 && extraInfoForPin.winRatio <= 100) {
                moveXVal = 3;
                moveYVal = 3;
                wiggles = 50;
            } else {
                moveXVal = 4;
                moveYVal = 4;
                wiggles = 40;
            }
        }
        let wiggleTl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y: string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;
        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles: wiggles,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });
        wiggleTl.to(NolimitApplication.pixiApp.stage, {
            duration: dur,
            x: x,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(NolimitApplication.pixiApp.stage, {
            duration: dur,
            y: y,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(NolimitApplication.pixiApp.stage, {x: stageOriginalPos.x, y: stageOriginalPos.y, duration: 0.01});
        return wiggleTl;
    }

    private createPinTheWinSpriteCont(): PIXI.Container {
        const conatiner: PIXI.Container = new PIXI.Container();
        for (let i: number = 1; i < 7; i++) {
            const pinSprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures(`ptwPin${i}`)[0]);
            pinSprite.name = "pin" + i;
            pinSprite.anchor.set(0.5);
            pinSprite.height = this._pinTheWinHeight;
            pinSprite.width = this._pinTheWinWidth;
            pinSprite.visible = false;
            conatiner.addChild(pinSprite);
        }

        conatiner.visible = false;
        conatiner.alpha = 0;
        if (Loner.model.isRestore && Loner.model.pinTheWinFeatureObj.retorePos) {
            const restorePos: number[] = Loner.model.pinTheWinFeatureObj.retorePos;
            conatiner.position = this.getAbsoluteHitPos(restorePos[0], restorePos[1]);
            this.setCurrentPositionOfPin(restorePos[0], restorePos[1]);
        } else {
            conatiner.position = this.getAbsoluteHitPos(2, 2);
            this.setCurrentPositionOfPin(2, 2);
        }
        return conatiner;
    }

    private getPinReelPositionFilled(): void {
        this._pinPositionsOnReels = [
            [[49, 182], [49, 276], [49, 354], [49, 432], [49, 526]],
            [[216, 182], [216, 268], [216, 354], [216, 440], [216, 526]],
            [[360, 182], [360, 268], [360, 354], [360, 440], [360, 526]],
            [[504, 182], [504, 268], [504, 354], [504, 440], [504, 526]],
            [[674, 182], [674, 268], [674, 354], [674, 440], [674, 526]]
        ]
    }

    private setCurrentPositionOfPin(reelId: number, symId: number) {
        this._currentPositionOfPin[0] = reelId;
        this._currentPositionOfPin[1] = symId;
    }

    private getCurrentPosOfPinAsReelIdSymId(): number[] {
        return this._currentPositionOfPin;
    }

    private getMovingDistance(destReelId: number, destSymId: number): number {
        const currXPos: number = this.getAbsoluteHitPos(this.getCurrentPosOfPinAsReelIdSymId()[0], this.getCurrentPosOfPinAsReelIdSymId()[1]).x,
            currYPos: number = this.getAbsoluteHitPos(this.getCurrentPosOfPinAsReelIdSymId()[0], this.getCurrentPosOfPinAsReelIdSymId()[1]).y,
            destXPos: number = this.getAbsoluteHitPos(destReelId, destSymId).x,
            destYPos: number = this.getAbsoluteHitPos(destReelId, destSymId).y;
        return Math.sqrt(Math.pow((destXPos - currXPos), 2) + Math.pow(Math.abs(destYPos - currYPos), 2));
    }

    private getTimeToTravel(distance: number, speed: number): number {
        return distance / speed;
    }
}